import React, { Component } from "react";
import "./ConfirmDeleteModal.css"; // Opcional: para tus estilos personalizados

class ConfirmDeleteModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      input: "",
    };
  }

  handleChange = (e) => {
    this.setState({ input: e.target.value });
  };

  handleConfirm = () => {

    const { confirmWord = "Eliminar", onConfirm } = this.props;
    if (this.state.input === confirmWord) {
      onConfirm();
    }
  };

  render() {
    const { onClose, title = "¿Estás seguro?", message = "Esta acción eliminará el elemento.", confirmWord = "Eliminar" } = this.props;
    const { input } = this.state;

    return (
      <div className="modal-backdrop">
        <div className="modal-box">
          <h2>{title}</h2>
          <p>{message}</p>
          <p>
            Escribe <strong>{confirmWord}</strong> para confirmar:
          </p>
          <input
            type="text"
            value={input}
            onChange={this.handleChange}
            placeholder={`Escribe "${confirmWord}"`}
          />
          <div className="modal-actions">
            <button onClick={onClose}>Cancelar</button>
            <button
              onClick={this.handleConfirm}
              disabled={input !== confirmWord}
            >
              Confirmar
            </button>
          </div>
        </div>
      </div>
    );
  }
}


export default ConfirmDeleteModal;
